/**
 * Created by rxsl-101 on 2020/5/12.
 */
import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

// 个体化配件选择列表
import SwbSpecificAccListForSelect from './SpecificAccListForSelect';
Vue.regist(SwbSpecificAccListForSelect);
export function openSpecificAccListForSelectDlg(dlgConfig, callback) {
    let title = dlgConfig["title"] || "个体化配件 - 选择";
    let retailerComId = dlgConfig["retailerComId"];
    let checkBox = Utils.isTrue(dlgConfig["checkBox"]);
    let disabledSelect = Utils.isTrue(dlgConfig["disabledSelect"]);
    let selectIds = dlgConfig["selectIds"] || [];
    let filter = dlgConfig["filter"] || {};
    let showTab = dlgConfig["showTab"];
    let defActiveName = dlgConfig["defActiveName"];
    let theDlg = Vue.$showDialog({
        title: title,
        width: -400,
        height: 900,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-specific-acc-list-for-select :filter="filter" :checkBox="checkBox" :disabledSelect="disabledSelect" :selectIds="selectIds" :showTab="showTab" :defActiveName="defActiveName" ref="swb_specific_acc_list_for_select"></swb-specific-acc-list-for-select>',
        data: {
            filter: filter,
            checkBox: checkBox,
            disabledSelect: disabledSelect,
            selectIds: selectIds,
            showTab: showTab,
            defActiveName: defActiveName
        },
        okClicked: function () {
            let self = this;
            let theLoad = MsgBox.loading();
            setTimeout(function () {
                let result = self.$refs.swb_specific_acc_list_for_select.getDlgResult() || {};
                if(result.type === 'info') {
                    let specificAccList = result.data || [];
                    callback(specificAccList, theDlg);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            }, 0);
            return false;
        }
    });
}

//
import SwbSpecificAccRepairVoucherSave from './SpecificAccRepairVoucherSave';
Vue.regist(SwbSpecificAccRepairVoucherSave);
// 配件返修单新增
export function openSpecificAccRepairVoucherSaveDlg(dlgConfig, callback) {
    let voucherId = dlgConfig['voucherId'] || null;
    let retailerComId = dlgConfig['retailerComId'];
    //
    let title = '返修单 - 新增';
    if(!Utils.isNoB(voucherId)) {
        title = '返修单 - 编辑';
    }
    let theDlg = Vue.$showDialog({
        title: title,
        width: -100,
        height: 800,
        showCloseBtn: true,
        template: '<swb-specific-acc-repair-voucher-save :voucherId="voucherId" :retailerComId="retailerComId" ref="swb_specific_acc_repair_voucher_save"></swb-specific-acc-repair-voucher-save>',
        data: {
            voucherId: voucherId,
            retailerComId: retailerComId
        },
        methods: {},
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_specific_acc_repair_voucher_save.getDlgResult() || {};
            if(result.type == 'info') {
                callback(result.data, theDlg);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
        }
    });
}

//
import SwbSpecificAccRepairVoucherDetail from './SpecificAccRepairVoucherDetail';
Vue.regist(SwbSpecificAccRepairVoucherDetail);
// 设备租赁详情
export function openSpecificAccRepairVoucherDetailDlg(dlgConfig, callback) {
    let voucherId = dlgConfig['voucherId'] || null;
    let title = '返修单 - 查看';
    let theDlg = Vue.$showDialog({
        title: title,
        width: -100,
        height: 800,
        showCloseBtn: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-specific-acc-repair-voucher-detail :voucherId="voucherId" ref="swb_specific_acc_repair_voucher_detail"></swb-specific-acc-repair-voucher-detail>',
        data: {
            voucherId: voucherId
        },
        methods: {},
        okClicked: function () {
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/accStock/dialog.js
// module id = 334
// module chunks = 0